export enum LiveComponentFromDialogueSource {
  LiveAgentRecommender,
  ChannelOptionLive,
}

// 按上报系统所给描述填的
// https://trafficsuite.shopee.io/tms/tracker/request/6980
export enum HAS_SCROLL_TO_END {
  TRUE = 0,
  FALSE,
}
